/* PACKAGES */
import { motion } from "framer-motion";

/* ANIMATION */
import { animation } from "config/animation";

const WhyChooseDFA = () => {
  return (
    <motion.div variants={animation} className="py-6 xl:py-12 lg:py-12">
      <div className="container">
        <h2 className="text-2xl xl:text-3xl lg:text-3xl font-source font-bold text-black tracking-tight">
          Why Choose Dream Force Academy?
        </h2>
        <h5 className="mt-5 text-base font-source font-normal text-black">
          Your choice of educational institution stands as the foundation for
          building a prosperous real estate career. Our training programs at
          Dream Force Academy maintain their position as one of the best real
          estate programs in California with these key characteristics:
        </h5>
        <div className="mt-5 grid grid-cols-1 xl:grid-cols-3 lg:grid-cols-3 gap-y-5 xl:gap-5 lg:gap-5">
          <div className="col-span-1">
            <div className="h-full bg-white border border-[#E5E5E5] rounded-lg shadow p-5">
              <p className="mt-1 text-base font-source font-normal text-greyText">
                Our customized curriculum brings together complete real estate
                education through detailed subject coverage.
              </p>
            </div>
          </div>
          <div className="col-span-1">
            <div className="h-full bg-white border border-[#E5E5E5] rounded-lg shadow p-5">
              <p className="mt-1 text-base font-source font-normal text-greyText">
                You will experience an enhanced learning process through access
                to contemporary resources and advanced materials.
              </p>
            </div>
          </div>
          <div className="col-span-1">
            <div className="h-full bg-white border border-[#E5E5E5] rounded-lg shadow p-5">
              <p className="mt-1 text-base font-source font-normal text-greyText">
                The career support services at our organization offer more than
                just education; it’s also about providing you with specialized
                career advancement guidance.
              </p>
            </div>
          </div>
        </div>
        <h5 className="mt-5 text-base font-source font-normal text-black">
          Start your real estate career path at Dream Force Academy because our
          combination of education and excellence prepares you for real estate
          success.
        </h5>
      </div>
    </motion.div>
  );
};

export default WhyChooseDFA;
